<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
  <div class="container-admin-integration-navigation">
    <div class="card">
      <div class="content">
        <app-header [title]="'Integrations'" [description]="'Connect Frankli with your favourite applications'"></app-header>

        <div class="area-integrations-group" *ngIf="
          globals.hasFeature(eCompanyFeatures.MERGE) ||
          globals.hasFeature(eCompanyFeatures.AZURE_ACTIVE_DIRECTORY) ||
          globals.hasFeature(eCompanyFeatures.PEOPLE_HR) ||
          globals.hasFeature(eCompanyFeatures.TRINET_HRIS) ||
          globals.hasFeature(eCompanyFeatures.SAGE_HR)
        ">
          <div class="p-bottom-15">
            <h2 class="standard-heading">HRIS, CRM & Ticketing Integrations</h2>
          </div>

          <!-- Merge.dev -->
          <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.MERGE) && !(globals.hasAnyFeature([eCompanyFeatures.AZURE_ACTIVE_DIRECTORY, eCompanyFeatures.PEOPLE_HR, eCompanyFeatures.SAGE_HR, eCompanyFeatures.TRINET_HRIS]))">
          <div class="card card-merge no-margin" [attr.data-intercom-target]="'HRIS Integrations'" (click)="navigateToIntegration('merge')">
              <div class="content">
                <div class="card-merge-inner">
                  <img src="assets/img/integrations/merge.svg"/>
                  <div class="card-merge-text">
                    <h4 class="standard-heading">Manage your integration using Merge (Beta)</h4>
                    <div>
                      <div>Frankli supports a wide range of HRIS, CRM, and Ticketing integrations.</div>
                      <div>With access to over 50 HRIS systems, 30 Ticketing platforms, and 20 CRMs, you can easily connect your preferred tools to Frankli.</div>
                      <div>Click here to browse available integrations.</div>
                    </div>
                  </div>
                  <span class="fal fa-fw fa-chevron-right"></span>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="
            globals.hasFeature(eCompanyFeatures.AZURE_ACTIVE_DIRECTORY) ||
            globals.hasFeature(eCompanyFeatures.PEOPLE_HR) ||
            globals.hasFeature(eCompanyFeatures.TRINET_HRIS) ||
            globals.hasFeature(eCompanyFeatures.SAGE_HR)
            ">
            <div class="area-integrations-grid" [class.m-top-15]="globals.hasFeature(eCompanyFeatures.MERGE)">
              <!-- Active Directory Integration -->
              <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.AZURE_ACTIVE_DIRECTORY)">
                <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Active Directory'" (click)="navigateToIntegration('active-directory')">
                  <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/azure.svg" />
                  <div class="admin-card-title">Azure Active Directory</div>
                  <div class="admin-card-description">Provision and De-Provision people from Azure Active Directory</div>
                </div>
              </ng-container>
    
              <!-- PeopleHR Integration -->
              <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.PEOPLE_HR)">
                <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - People HR'" (click)="navigateToIntegration('people-hr')">
                  <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/people-hr.svg"/>
                  <div class="admin-card-title">People HR</div>
                  <div class="admin-card-description">Provision and De-Provision people from People HR</div>
                </div>
              </ng-container>
    
              <!-- TriNet Integration -->
              <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.TRINET_HRIS)">
                <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - TriNet HRIS'" (click)="navigateToIntegration('trinet')">
                  <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/object-intersect.svg"/>
                  <div class="admin-card-title">TriNet</div>
                  <div class="admin-card-description">Provision and De-Provision people from TriNet</div>
                </div>
              </ng-container>
    
              <!-- SageHR Integration-->
              <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.SAGE_HR)">
                <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Sage HR HRIS'" (click)="navigateToIntegration('sagehr')">
                  <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/sage-hr.svg"/>
                  <div class="admin-card-title">SAGE HR</div>
                  <div class="admin-card-description">Provision and De-Provision people from Sage HR</div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div class="area-integrations-group">
          <div class="p-bottom-15">
            <h2 class="standard-heading">Other integrations</h2>
          </div>

          <div class="area-integrations-grid">
            <!-- Slack Integration -->
            <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Slack'" (click)="navigateToIntegration('slack')">
              <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/slack.svg"/>
              <div class="admin-card-title">Slack</div>
              <div class="admin-card-description">Send praise right from Slack</div>
            </div>
  
            <!-- Vincere Integration -->
            <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.VINCERE)">
              <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Vincere'" (click)="navigateToIntegration('vincere')">
                <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/vincere.svg"/>
                <div class="admin-card-title">Vincere</div>
                <div class="admin-card-description">Get employee statistics from Vincere</div>
              </div>
            </ng-container>
  
            <!-- Zendesk Integration -->
            <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.ZENDESK)">
              <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Zendesk'" (click)="navigateToIntegration('zendesk')">
                <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/zendesk.svg"/>
                <div class="admin-card-title">Zendesk</div>
                <div class="admin-card-description">Get employee statistics from Zendesk</div>
              </div>
            </ng-container>

            <!-- EvaluAgent Integration -->
            <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.EVALUAGENT)">
              <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - Evaluagent'" (click)="navigateToIntegration('evaluagent')">
                <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/evaluagent.svg"/>
                <div class="admin-card-title">EvaluAgent</div>
                <div class="admin-card-description">Get employee statistics from EvaluAgent</div>
              </div>
            </ng-container>

            <!-- Absorb LMS Integration -->
            <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.ABSORBLMS)">
              <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - AbsorbLms'" (click)="navigateToIntegration('absorblms')">
                <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/absorblms.svg"/>
                <div class="admin-card-title">Absorb LMS</div>
                <div class="admin-card-description">Display certificates from Absorb on your profile</div>
              </div>
            </ng-container>

            <!-- ZendeskQA Integration -->
            <ng-container *ngIf="globals.hasFeature(eCompanyFeatures.ZENDESKQA)">
              <div class="card admin-card text-center" [attr.data-intercom-target]="'Integration - ZendeskQA'" (click)="navigateToIntegration('zendeskqa')">
                <img class="admin-icon" width="100px" height="100px" src="/assets/img/integrations/zendesk.svg"/>
                <div class="admin-card-title">Zendesk QA</div>
                <div class="admin-card-description">View support rep IQS from Zendesk QA</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
